(() => {
  if (window.ldsAcuraCartModalReady) return;
  window.ldsAcuraCartModalReady = true;

  const rootPath = window.Shopify?.routes?.root || '/';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'USD'
  }).format(cents / 100);
  const modal = document.createElement('dialog');
  modal.className = 'lds-acura-cart-modal';
  modal.setAttribute('aria-labelledby', 'LdsAcuraCartModalTitle');
  modal.innerHTML = `
    <div class="lds-acura-cart-modal__shell">
      <button type="button" class="lds-acura-cart-modal__close" aria-label="Close option chooser">×</button>
      <div class="lds-acura-cart-modal__product">
        <img class="lds-acura-cart-modal__image" alt="" width="160" height="160">
        <div><p class="lds-acura-cart-modal__eyebrow">COMPLETE YOUR ACURA LOOK</p><h2 id="LdsAcuraCartModalTitle"></h2><p class="lds-acura-cart-modal__price" data-lds-cart-modal-price></p></div>
      </div>
      <form class="lds-acura-cart-modal__form">
        <div class="lds-acura-cart-modal__options" data-lds-cart-modal-options></div>
        <label class="lds-acura-cart-modal__custom" data-lds-cart-modal-custom hidden>Custom logo or text request
          <textarea rows="3" maxlength="500" placeholder="Write your text or describe your logo. You can reply to the order confirmation with your logo file."></textarea>
          <small>For a logo file, reply to your order confirmation email.</small>
        </label>
        <p class="lds-acura-cart-modal__error" data-lds-cart-modal-error role="alert" hidden></p>
        <button type="submit" class="lds-acura-cart-modal__add" data-lds-cart-modal-add>Add to cart</button>
      </form>
    </div>`;
  document.body.appendChild(modal);
  const form = modal.querySelector('form');
  const optionWrap = modal.querySelector('[data-lds-cart-modal-options]');
  const customWrap = modal.querySelector('[data-lds-cart-modal-custom]');
  const customInput = customWrap.querySelector('textarea');
  const price = modal.querySelector('[data-lds-cart-modal-price]');
  const error = modal.querySelector('[data-lds-cart-modal-error]');
  const addButton = modal.querySelector('[data-lds-cart-modal-add]');
  let product = null;
  let selected = null;
  let busy = false;
  let opening = false;
  let opener = null;

  const showError = message => {
    error.textContent = message;
    error.hidden = !message;
  };
  const preserveCartPosition = () => {
    const pageY = window.scrollY;
    const drawerScroll = document.querySelector('hdt-cart-drawer [data-hdt-scroll-me]')?.scrollTop;
    const controller = new AbortController();
    const restore = () => requestAnimationFrame(() => {
      window.scrollTo(0, pageY);
      const scroller = document.querySelector('hdt-cart-drawer [data-hdt-scroll-me]');
      if (scroller && drawerScroll != null) scroller.scrollTop = drawerScroll;
    });
    document.addEventListener('cart:main:render', restore, { signal: controller.signal, once: true });
    document.addEventListener('cart:drawer:render', restore, { signal: controller.signal, once: true });
    setTimeout(() => controller.abort(), 2000);
  };
  const chosenValues = () => [...optionWrap.querySelectorAll('select')].map(select => select.value);
  const update = () => {
    if (!product) return;
    const values = chosenValues();
    selected = product.variants.find(variant => values.every((value, index) => variant[`option${index + 1}`] === value));
    const custom = values.some(value => /custom/i.test(value));
    customWrap.hidden = !custom;
    customInput.disabled = !custom;
    customInput.required = custom;
    price.textContent = selected ? money(selected.price) : 'Combination unavailable';
    const image = modal.querySelector('.lds-acura-cart-modal__image');
    image.src = selected?.featured_image?.src || product.featured_image || product.images?.[0] || '';
    image.alt = selected ? `${product.title} — ${selected.title}` : product.title;
    addButton.disabled = busy || !selected?.available;
    addButton.textContent = busy ? 'Adding…' : selected?.available ? `Add to cart · ${money(selected.price)}` : 'Unavailable';
  };
  const close = () => { if (!busy && modal.open) modal.close(); };
  modal.querySelector('.lds-acura-cart-modal__close').addEventListener('click', close);
  modal.addEventListener('click', event => { if (event.target === modal) close(); });
  modal.addEventListener('cancel', event => { if (busy) event.preventDefault(); });
  modal.addEventListener('close', () => { if (opener?.isConnected) opener.focus(); opener = null; });
  optionWrap.addEventListener('change', () => { showError(''); update(); });

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-lds-acura-choose]');
    if (!button || busy || opening) return;
    opener = button;
    opening = true;
    button.disabled = true;
    const cardError = button.parentElement.querySelector('[data-lds-acura-card-error]');
    if (cardError) { cardError.textContent = ''; cardError.hidden = true; }
    try {
      const response = await fetch(`${button.dataset.productUrl}.js`, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Could not load product options. Please try again.');
      product = await response.json();
      modal.querySelector('#LdsAcuraCartModalTitle').textContent = button.dataset.productName || product.title;
      modal.querySelector('.lds-acura-cart-modal__eyebrow').textContent = `COMPLETE YOUR ${(button.dataset.upsellBrand || 'Acura').toUpperCase()} LOOK`;
      const image = modal.querySelector('.lds-acura-cart-modal__image');
      image.src = product.featured_image || product.images?.[0] || '';
      image.alt = product.title;
      optionWrap.replaceChildren();
      for (const option of product.options) {
        const label = document.createElement('label');
        label.textContent = option.name;
        const select = document.createElement('select');
        select.name = option.name;
        for (const value of option.values) select.add(new Option(value, value));
        label.appendChild(select);
        optionWrap.appendChild(label);
      }
      const preferredColor = button.dataset.preferredColor?.trim().toLowerCase();
      const colorIndex = product.options.findIndex(option => /color/i.test(option.name));
      const matchingColor = preferredColor && colorIndex >= 0
        ? product.variants.find(variant => variant.available && variant[`option${colorIndex + 1}`]?.toLowerCase() === preferredColor)
        : null;
      const first = matchingColor || product.variants.find(variant => variant.available) || product.variants[0];
      optionWrap.querySelectorAll('select').forEach((select, index) => { select.value = first?.[`option${index + 1}`] || ''; });
      customInput.value = '';
      showError('');
      update();
      modal.showModal();
      optionWrap.querySelector('select')?.focus();
    } catch (cause) {
      if (cardError) { cardError.textContent = cause.message; cardError.hidden = false; }
      opener = null;
    } finally {
      opening = false;
      button.disabled = false;
    }
  });

  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy || !selected?.available) return;
    const custom = !customInput.disabled;
    const design = customInput.value.trim();
    if (custom && !design) {
      showError('Describe the custom logo or text before adding this item.');
      customInput.focus();
      return;
    }
    busy = true;
    update();
    try {
      const sections = [...new Set([...document.querySelectorAll('hdt-main-cart[section-id], hdt-cart-drawer[section-id]')].map(element => element.getAttribute('section-id')).filter(Boolean))];
      const item = { id: selected.id, quantity: 1 };
      if (custom) item.properties = { 'Custom design request': design };
      const response = await fetch(`${rootPath}cart/add.js`, {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item], sections, sections_url: window.location.pathname })
      });
      const raw = await response.text();
      let result;
      try { result = JSON.parse(raw); } catch { result = {}; }
      if (!response.ok) throw new Error(result.description || result.message || 'The item could not be added. Please try again.');
      const complete = sections.every(section => result.sections?.[section]);
      preserveCartPosition();
      if (complete) document.dispatchEvent(new CustomEvent('cart:update', { detail: { cartData: result, source: 'lds-acura-cart-modal', actionAfterATC: 'no_action' } }));
      else document.dispatchEvent(new CustomEvent('cart:reload'));
      opener = null;
      modal.close();
    } catch (cause) {
      showError(cause.message || 'Could not add this item. Please try again.');
    } finally {
      busy = false;
      update();
    }
  });
})();
